// Card primitive — port of design/v3/Primitives.jsx (Card).

import type { CSSProperties, ReactNode, MouseEvent } from 'react';

export interface CardProps {
  children?: ReactNode;
  style?: CSSProperties;
  className?: string;
  warning?: boolean;
  danger?: boolean;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
}

export function Card({
  children,
  style,
  className,
  warning,
  danger,
  onClick,
}: CardProps) {
  const border = danger
    ? 'var(--danger)'
    : warning
      ? 'var(--warning)'
      : 'var(--border-weak)';
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        background: 'var(--bg-surface)',
        border: `1px solid ${border}`,
        borderRadius: 'var(--radius-lg)',
        boxShadow: 'var(--shadow-xs)',
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 180ms var(--ease-out)',
        ...style,
      }}
    >
      {children}
    </div>
  );
}
